
export function useVerseBackground() {
  const getDailyBackground = () => {
    const backgrounds = [
      "lovable-uploads/1b5f601f-4627-4e8d-8fd8-0f2d55062ae8.png",
      "lovable-uploads/2d4b3061-fe79-43e0-a306-95effbcf1e13.png",
      "lovable-uploads/6e301e42-c1b2-46a8-abb2-1268de18b1b5.png",
    ];
    const today = new Date();
    const start = new Date(today.getFullYear(), 0, 0);
    const diff = today.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);
    return backgrounds[dayOfYear % backgrounds.length];
  };

  const backgroundStyle = {
    backgroundImage: `linear-gradient(rgba(26, 31, 44, 0.85), rgba(26, 31, 44, 0.85)), url(/${getDailyBackground()})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return backgroundStyle;
}
